module.exports = __webpack_public_path__ + "img/adv_all.5c546b5f.png";